/* Логика для страниц каталога фильтрации программ */
const catalog = (allPrograms) => {
  if (!document.querySelector("[data-catalog-filters]")) {
    return;
  }

  const utmCategory = getParam("category"),
    utmLevel = getParam("level"),
    utmRecruitment = getParam("recruitment"),
    utmRegion = getParam("region"),
    inputsCategory = document.querySelectorAll('input[name="category"]'),
    inputsLevel = document.querySelectorAll('input[name="level"]'),
    inputsRecruitment = document.querySelectorAll('input[name="recruitment"]'),
    linksPrograms = document.querySelectorAll(".tile-link"),
    linksDirections = document.querySelectorAll("[catalog-filter]"),
    notFound = document.querySelector(".tiles__not-found"),
    wrap = document.querySelector(".tiles__programs"),
    selectRegions = document.getElementById("CatalogRegions");

  /* Список программ доступных для категории ищущих */
  const list = [
    "onec144",
    "accountant",
    "personneladmin",
    "methodist",
    "bpla",
    "preschool-education",
    "social-worker",
    "social-specialist",
    "softwaretesting",
    "webprogrammer",
  ];

  /* Инициализация */
  (() => {
    // Добавление активности для инпута на основе данных из utm метки
    if (utmCategory) {
      inputsCategory.forEach((input) => {
        if (input.value == utmCategory) {
          input.setAttribute("checked", "true");
        }
      });
    }

    if (utmLevel) {
      inputsLevel.forEach((input) => {
        if (input.value == utmLevel) {
          input.setAttribute("checked", "true");
        }
      });
    }

    if (utmRecruitment) {
      inputsRecruitment.forEach((input) => {
        if (input.value == utmRecruitment) {
          input.setAttribute("checked", "true");
        }
      });
    }

    addCardsClass();
    update();
    if (utmRegion) {
      $("#CatalogRegions").val(utmRegion);
      $("#CatalogRegions").trigger("change");
    }
    filterRegions(utmRegion);
    resetAllFilters();

    /* Замена текста в плашках для программ категории ищущих */
    linksPrograms.forEach((tile) => {
      if (list.includes(returnPageProgram(tile.href))) {
        if (!tile.closest(".tile").classList.contains("disable")) {
          let field = tile
            .closest(".tile")
            .querySelector(".tile__header-info-cost--employed");
          field.textContent = "Бесплатно";
        }
      }
    });
  })();

  /* Функция добавления UTM меток в url сайта */
  const updateQueryStringParam = function (key, value) {
    let url = new URL(document.location.href);

    url.searchParams.set(key, value);
    window.history.replaceState({}, "", url.href);
  };

  /* Событие на чекбокс категории */
  inputsCategory.forEach((input) => {
    input.addEventListener("change", () => {
      updateQueryStringParam("category", input.value);
      update();
      filterRegions(utmRegion);
      scrollToTop();
    });
  });

  /* Событие на чекбокс уровня образования */
  inputsLevel.forEach((input) => {
    input.addEventListener("change", () => {
      updateQueryStringParam("level", input.value);
      update();
      filterRegions(utmRegion);
      scrollToTop();
    });
  });

  /* Событие на чекбокс активного набора */
  inputsRecruitment.forEach((input) => {
    input.addEventListener("change", () => {
      updateQueryStringParam("recruitment", input.value);
      update();
      filterRegions(utmRegion);
      scrollToTop();

      // Блокировка селекта по регионам
      if (input.value == "disable") {
        selectRegions.setAttribute("disabled", "disabled");
      } else {
        selectRegions.removeAttribute("disabled");
      }
    });
  });

  /* Событие на селект региона */
  selectRegions.onchange = (e) => {
    let target = e.target.value;
    updateQueryStringParam("region", target);
    update();
    filterRegions(target);
    scrollToTop();
  };

  /* Обновление контента */
  function update() {
    filterPrograms(searchValueCheckbox(inputsCategory));
    blockDisplayLogic(
      searchValueCheckbox(inputsLevel),
      searchValueCheckbox(inputsRecruitment)
    );
    addLinks();
  }

  /* Отображение или скрытие блока списка программ и notFound */
  function blockDisplayLogic(level, filter) {
    let countDPO = countPrograms(".tiles__DPO", "enable"),
      countPO = countPrograms(".tiles__PO", "enable"),
      DPO = document.querySelector(".tiles__DPO"),
      PO = document.querySelector(".tiles__PO");

    if (level == "DPO") {
      DPO.style.display = "block";
      if (PO) {
        PO.style.display = "none";
      }

      if (countDPO < 1) {
        wrap.style.display = "none";
        notFound.style.display = "flex";
      } else {
        wrap.style.display = "flex";
        notFound.style.display = "none";
      }
    } else if (level == "PO") {
      DPO.style.display = "none";
      if (PO) {
        PO.style.display = "block";
      }

      if (countPO < 1) {
        wrap.style.display = "none";
        notFound.style.display = "flex";
      } else {
        wrap.style.display = "flex";
        notFound.style.display = "none";
      }
    } else {
      if (countDPO < 1 && countPO < 1) {
        wrap.style.display = "none";
        notFound.style.display = "flex";
      } else if (countPO < 1) {
        if (PO) {
          PO.style.display = "none";
        }
        wrap.style.display = "flex";
        notFound.style.display = "none";
      } else if (countDPO < 1) {
        if (DPO) {
          DPO.style.display = "none";
        }
        wrap.style.display = "flex";
        notFound.style.display = "none";
      } else {
        if (PO) {
          PO.style.display = "block";
        }
        if (DPO) {
          DPO.style.display = "block";
        }
        wrap.style.display = "flex";
        notFound.style.display = "none";
      }
    }

    //Фильтрация по активности программ
    if (filter == "disable") {
      let checkDisableDPO = [...linksPrograms].find((it) => {
        if (level == "DPO" && it.closest(".tiles__DPO")) {
          if (it.closest(".disable")) {
            return it;
          }
        }
      });
      
      let checkDisablePO = [...linksPrograms].find((it) => {
        if (level == "PO" && it.closest(".tiles__PO")) {
          if (it.closest(".disable")) {
            return it;
          }
        }
      });

      let checkDisablePOAll = [...linksPrograms].find((it) => {
        if (it.closest(".tiles__PO")) {
          if (it.closest(".disable")) {
            return it;
          }
        }
      });

      let checkDisableDPOAll = [...linksPrograms].find((it) => {
        if (it.closest(".tiles__DPO")) {
          if (it.closest(".disable")) {
            return it;
          }
        }
      });

      if (level == "DPO") {
        if (typeof checkDisableDPO == "undefined") {
          wrap.style.display = "none";
          notFound.style.display = "flex";
        }
      } else if (level == "PO") {
        if (typeof checkDisablePO == "undefined") {
          wrap.style.display = "none";
          notFound.style.display = "flex";
        }
      } else {
        if (typeof checkDisablePOAll == "undefined") {
          if (PO) {
            PO.style.display = "none";
          }
        } else {
          if (PO) {
            PO.style.display = "block";
          }
        }

        if (typeof checkDisableDPOAll == "undefined") {
          if (DPO) {
            DPO.style.display = "none";
          }
        } else {
          if (DPO) {
            DPO.style.display = "block";
          }
        }

        if (
          typeof checkDisableDPOAll == "undefined" &&
          typeof checkDisablePOAll == "undefined"
        ) {
          wrap.style.display = "none";
          notFound.style.display = "flex";
        }
      }

      [...linksPrograms].map((it) => {
        it.closest(".tile").style.display = "none";
        
        if (it.closest(".disable")) {
          it.closest(".tile").style.display = "flex";
        }
      });
    } else {
      const enablePrograms = document.querySelectorAll(".tile:not(.disable)");

      if (level == "DPO") {
        if (
          countPrograms(".tiles__DPO", "disable") ==
          countPrograms(".tiles__DPO", "enable")
        ) {
          if (DPO) {
            DPO.style.display = "none";
            wrap.style.display = "none";
            notFound.style.display = "flex";
          }
        }
      } else if (level == "PO") {
        if (
          countPrograms(".tiles__PO", "disable") ==
          countPrograms(".tiles__PO", "enable")
        ) {
          if (PO) {
            PO.style.display = "none";
            wrap.style.display = "none";
            notFound.style.display = "flex";
          }
        }
      } else {
        if (
          countPrograms(".tiles__DPO", "disable") ==
          countPrograms(".tiles__DPO", "enable")
        ) {
          if (DPO) {
            DPO.style.display = "none";
          }
        } else {
          if (DPO) {
            DPO.style.display = "block";
          }
        }

        if (
          countPrograms(".tiles__PO", "disable") ==
          countPrograms(".tiles__PO", "enable")
        ) {
          if (PO) {
            PO.style.display = "none";
          }
        } else {
          if (PO) {
            PO.style.display = "block";
          }
        }

        if (!enablePrograms.length) {
          wrap.style.display = "none";
          notFound.style.display = "flex";
        }
      }
    }
  }

  /* Фильтрация программ */
  function filterPrograms(filter) {
    if (filter == "employed") {
      let count = 0;

      linksPrograms.forEach((tile) => {
        if (list.includes(returnPageProgram(tile.href))) {
          if (count == 4) {
            count = 0;
          }

          count++;
          changeStateTiles(tile, count);
        } else {
          hiddenTiles(tile);
        }
      });
    } else {
      let count = 0;

      linksPrograms.forEach((tile) => {
        if (!tile.closest(".tile").classList.contains("disable")) {        
          if (count == 4) {
            count = 0;
          }
  
          count++;
          changeStateTiles(tile, count);
        } else {          
          tile.closest(".tile").style.display = "none";
        }
      });
    }
  }

  /* Сброс установок фильтров */
  function resetAllFilters() {
    let resetAllFilters = document.querySelector("[data-reset-all]");

    resetAllFilters.addEventListener("click", () => {
      document.location.href = "/catalog";
    });
  }

  /* Отобраение и замена цвета у карточек каталога */
  function changeStateTiles(tile, count) {
    const colors = [
      ["#FFB84F", "#FFC877"],
      ["#FF9F9F", "#FFBABE"],
      ["#64BBFF", "#82C7FC"],
      ["#9896FF", "#AFAEF2"],
    ];

    if (tile.closest(".tile").classList.contains("hidden")) {
      tile.closest(".tile").classList.remove("hidden");
    }
    
    tile.closest(".tile").style.backgroundColor = colors[count - 1][0];
    tile
      .closest(".tile")
      .querySelectorAll(".tile__header-icon")
      .forEach((icon) => (icon.style.backgroundColor = colors[count - 1][1]));

    tile.closest(".tile").style.display = "flex";
    tile.closest(".tile").classList.add("visible");
  }

  /* Скрытие карточки в каталоге */
  function hiddenTiles(tile) {
    if (tile.closest(".tile").classList.contains("visible")) {
      tile.closest(".tile").classList.remove("visible");
    }

    tile.closest(".tile").classList.add("hidden");
    tile.closest(".tile").style.display = "none";
  }

  /* Скрытие или отображение блока для программ ДПО и ПО */
  function countPrograms(block, filter) {
    const wrap = document.querySelector(block);

    if (!wrap) {
      return 0;
    }

    if (filter == "disable") {
      const programs = wrap.querySelectorAll(".tile.visible.disable");
      return programs.length;
    } else {
      const programs = wrap.querySelectorAll(".tile.visible");
      return programs.length;
    }
  }

  /* Добавление класса active или disable карточкам */
  function addCardsClass() {
    const enablePrograms = document.querySelectorAll(".tile:not(.disable)");

    let dataPrograms = [];

    allPrograms.forEach((program) => {
      dataPrograms.push(program.shortname);
    });

    enablePrograms.forEach((program) => {
      let link = program.getAttribute("data-link");      

      if (dataPrograms.includes(returnPageProgram(link))) {
        program.classList.add('active');
      } else {
        program.classList.add('disable');
      }
    });
  }

  /* Фильтрация по региону */
  function filterRegions(region = null) {
    const enablePrograms = document.querySelectorAll(".tile:not(.disable)");

    let dataPrograms = [];
    let listPrograms = [];

    allPrograms.forEach((program) => {
      dataPrograms.push(program.shortname);
    });

    enablePrograms.forEach((program) => {
      let link = program.getAttribute("data-link");      

      if (dataPrograms.includes(returnPageProgram(link))) {
        listPrograms.push(program);
      } 
    });

    if (!region) return;
    
    let list = [];
    let filterAllPrograms = allPrograms.filter((item) =>
      item.regions.some((it) => it.region_id == region)
    );

    filterAllPrograms.forEach((program) => {
      list.push(program.shortname);
    });    
    
    enablePrograms.forEach((program) => {
      program.style.display = "none";      
    });

    if (searchValueCheckbox(inputsRecruitment) != "disable") {
      listPrograms.forEach((program) => {
        let link = program.getAttribute("data-link");
  
        if (list.includes(returnPageProgram(link))) {
          program.style.display = "flex";
        } else {
          program.style.display = "none";
        }
      });      
    }
  }

  /* Добавление для ссылок на направлениях utm меток */
  function addLinks() {
    let category = searchValueCheckbox(inputsCategory),
      level = searchValueCheckbox(inputsLevel);

    if (category && !level) {
      linksDirections.forEach((link) => {
        let href = link.href;
        link.href = href.split("?")[0] + `?category=${category}`;
      });
    } else if (!category && level) {
      linksDirections.forEach((link) => {
        let href = link.href;
        link.href = href.split("?")[0] + `?level=${level}`;
      });
    } else if (category && level) {
      linksDirections.forEach((link) => {
        let href = link.href;
        link.href = href.split("?")[0] + `?category=${category}&level=${level}`;
      });
    } else {
      linksDirections.forEach((link) => {
        let href = link.href;
        link.href = href.split("?")[0];
      });
    }
  }

  /* Поиск выбранного чекбокса */
  function searchValueCheckbox(inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) {
        let value = inputs[i].value;

        return value;
      }
    }
  }

  /* Получение url программы из ссылки */
  function returnPageProgram(link) {
    const segments = link.split("/"),
      last = segments.pop() || segments.pop();

    return last;
  }

  /* Функция получения определенной utm метки */
  function getParam(param) {
    const urlParams = new URL(window.location.toString()).searchParams;
    return urlParams.get(param) || "";
  }

  /* Плавный скролл в начало блока списка программ */
  function scrollToTop() {
    let scropllBlock = document.querySelector(".tiles-wrap");
    if (scropllBlock) {
      scropllBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
};

export default catalog;
